import { differenceInYears, format } from "date-fns";
import moment from "moment";
export var requiredMessage = function requiredMessage(fieldName) {
  return "Please enter your ".concat(fieldName, ".");
};
export var pleaseEnterMessage = function pleaseEnterMessage(message) {
  return "Please enter ".concat(message, ".");
};
export var pleaseEnterTheMessage = function pleaseEnterTheMessage(message) {
  return "Please enter the ".concat(message, ".");
};
export var pleaseEnterAMessage = function pleaseEnterAMessage(message) {
  return "Please enter a ".concat(message, ".");
};
export var pleaseChoose = function pleaseChoose(fieldName) {
  return "Please choose your ".concat(fieldName, ".");
};
export var pleaseConfirm = function pleaseConfirm(fieldName) {
  return "Please confirm ".concat(fieldName, ".");
};
export var youMustConfirm = function youMustConfirm(fieldName) {
  return "You must confirm that ".concat(fieldName, ".");
};
export var youMustDeclare = function youMustDeclare(fieldName) {
  return "You must declare that ".concat(fieldName, ".");
};
export var youHaveRead = function youHaveRead(files) {
  return "you have read and understood the ".concat(files);
};
export var yourOrThePrefix = function yourOrThePrefix() {
  var funnel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "ARHI";
  return funnel !== "IAP" ? "your" : "the";
};
export var iapTooOldChildrensMessage = function iapTooOldChildrensMessage(maxYearsAgo) {
  return "Children and dependants must be under the age of ".concat(maxYearsAgo, " years. Please contact your account manager for help.");
};
export var iapTooOldMessage = function iapTooOldMessage(maxYearsAgo, isDependant, isPartner, customApplicantType) {
  if (isDependant) {
    return iapTooOldChildrensMessage(maxYearsAgo);
  }
  var applicantType = isPartner ? "Partner applicants" : "Students";
  return "".concat(customApplicantType || applicantType, " older than ").concat(maxYearsAgo, " years of age cannot join nib online. Please contact your account manager for help.");
};
export var iapTooYoungMessage = function iapTooYoungMessage(minYearsAgo, isPartner, customApplicantType) {
  var applicantType = isPartner ? "Partner applicants" : "Students";
  return "".concat(customApplicantType || applicantType, " must be ").concat(minYearsAgo, " years or older to join nib online. Please contact your account manager for help.");
};
export var tooOldMessage = function tooOldMessage(applicationType, maxYearsAgo, funnelName, funnelPhone, funnel) {
  var isDependant = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  var isPartner = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
  return "Unfortunately ".concat(applicationType, " older than ").concat(maxYearsAgo, " years of age cannot join ").concat(funnelName, " online. Please contact us on ").concat(funnelPhone, " for help.");
};
export var tooYoungMessage = function tooYoungMessage(minYearsAgo, funnelName, funnelPhone, funnel) {
  var isDependant = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var isPartner = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  return "You must be ".concat(minYearsAgo, " years or older to join ").concat(funnelName, " online. Please contact us on ").concat(funnelPhone, " for help.");
};
export var DOB_MUST_BE_IN_PAST_MESSAGE = "Date of birth must be in the past.";
export var maxLength = function maxLength(value) {
  return function (length) {
    return value.length > length;
  };
};
export var minLength = function minLength(value) {
  return function (length) {
    return value.length < length;
  };
}; // I take the number 7 and return 07 but if number 10 I just return 10
export var leadingZero = function leadingZero(value) {
  return Number(value).toString().length < 2 ? "0".concat(Number(value)) : "".concat(value);
};
export var capitalise = function capitalise(string) {
  if (typeof string !== "string") return "";
  return string.charAt(0).toUpperCase() + string.slice(1);
};
export var isCustomerTooOld = function isCustomerTooOld(dobString) {
  var maxYearsAgo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  var dob = moment(new Date(dobString));
  var dateToday = moment(new Date(format(new Date(), "yyyy-MM-dd")));
  var age = dateToday.diff(dob, "years", true);
  return age >= maxYearsAgo;
};
export var isCustomerTooYoung = function isCustomerTooYoung(dobString) {
  var minYearsAgo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 18;
  var dob = new Date(dobString);
  var dateToday = new Date(format(new Date(), "yyyy-MM-dd"));
  var age = differenceInYears(dateToday, dob);
  return age < minYearsAgo;
};
export var isWeeklyOrFortnightlyFrequency = function isWeeklyOrFortnightlyFrequency(paymentFrequency) {
  return paymentFrequency === "Weekly" || paymentFrequency === "Fortnightly";
};
export var maxMonthFutureLimit = function maxMonthFutureLimit(fieldName, months) {
  return "".concat(capitalise(fieldName), " cannot be more than ").concat(months, " month").concat(months !== 1 ? "s" : "", " in the future.");
};
export var accountName = function accountName(value) {
  return !/^[a-zA-Z| |\-|'|‘]*?$/.test(value);
}; // includes wide list of accented chars
// validator from join-api
export var firstOrLastName = function firstOrLastName(value) {
  return !/^(?!.*(-{2}))^[a-zA-Z0-9\-' ]*$/.test(value);
}; // eslint-disable-next-line no-useless-escape
export var existingConditionDescription = function existingConditionDescription(value) {
  return !/^(.|\s)*[a-zA-Z]+(.|\s)*$/.test(value);
};
export var isInvalidMembershipNumber = function isInvalidMembershipNumber(value) {
  return !/^[a-zA-Z0-9]*$/.test(value);
};
export var toISODate = function toISODate(value) {
  if (!value) {
    return value;
  }
  var dateSplitToArray = value.split("-");
  if (dateSplitToArray) {
    return "".concat(dateSplitToArray[0], "-").concat(leadingZero(dateSplitToArray[1]), "-").concat(leadingZero(dateSplitToArray[2]));
  } else {
    return value;
  }
};
export var PHONE_NUMBERS = {
  ARHI: "13 16 42",
  NIBP2PWEB: "13 16 42",
  APIA: "13 50 50",
  GU: "1800 249 966",
  IMAN: "1800 221 133",
  IWHI: "1800 775 204",
  ISHI: "1800 775 204",
  ING: "1800 111 831",
  SUNCORP: "13 11 55",
  AAMI: "13 22 44",
  PRICELINE: "1300 070 761"
};
export var FUNNEL_NAMES = {
  ARHI: "nib",
  NIBP2PWEB: "dental pass",
  APIA: "Apia health insurance",
  GU: "GU Health",
  IMAN: "IMAN",
  IWHI: "nib",
  ISHI: "nib",
  IAP: "nib",
  ING: "ING",
  SUNCORP: "Suncorp",
  AAMI: "AAMI",
  PRICELINE: "Priceline Health Insurance"
};
var FUNNELS = {
  ARHI: "ARHI",
  APIA: "APIA",
  GU: "GU",
  IMAN: "IMAN",
  ISHI: "ISHI",
  IWHI: "IWHI",
  IAP: "IAP",
  ING: "ING",
  SUNCORP: "SUNCORP",
  AAMI: "AAMI",
  PRICELINE: "PRICELINE"
};
export var INTERNATIONAL_FUNNELS = [FUNNELS.IMAN, FUNNELS.ISHI, FUNNELS.IWHI, FUNNELS.IAP];